/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUserLocation
 */
export interface IUserLocation {
    /**
     * 
     * @type {string}
     * @memberof IUserLocation
     */
    org_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserLocation
     */
    group_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserLocation
     */
    user_auth_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IUserLocation
     */
    degrees_bearing?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IUserLocation
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof IUserLocation
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof IUserLocation
     */
    meters_per_second_speed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IUserLocation
     */
    creation_timestamp?: number;
    /**
     * 
     * @type {string}
     * @memberof IUserLocation
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserLocation
     */
    phone_number?: string | null;
}

/**
 * Check if a given object implements the IUserLocation interface.
 */
export function instanceOfIUserLocation(value: object): value is IUserLocation {
    return true;
}

export function IUserLocationFromJSON(json: any): IUserLocation {
    return IUserLocationFromJSONTyped(json, false);
}

export function IUserLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUserLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'] == null ? undefined : json['org_code'],
        'group_id': json['group_id'] == null ? undefined : json['group_id'],
        'user_auth_id': json['user_auth_id'] == null ? undefined : json['user_auth_id'],
        'degrees_bearing': json['degrees_bearing'] == null ? undefined : json['degrees_bearing'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'meters_per_second_speed': json['meters_per_second_speed'] == null ? undefined : json['meters_per_second_speed'],
        'creation_timestamp': json['creation_timestamp'] == null ? undefined : json['creation_timestamp'],
        'name': json['name'] == null ? undefined : json['name'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
    };
}

export function IUserLocationToJSON(json: any): IUserLocation {
    return IUserLocationToJSONTyped(json, false);
}

export function IUserLocationToJSONTyped(value?: IUserLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'group_id': value['group_id'],
        'user_auth_id': value['user_auth_id'],
        'degrees_bearing': value['degrees_bearing'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'meters_per_second_speed': value['meters_per_second_speed'],
        'creation_timestamp': value['creation_timestamp'],
        'name': value['name'],
        'phone_number': value['phone_number'],
    };
}

